// extracted by mini-css-extract-plugin
module.exports = {"root":"Loading_root__Wv7EE","spin":"Loading_spin__DPEV3"};